"use strict";
/*******************************************************************************

    Contains instances of requesting data from the server

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        MIT License. See LICENSE for details.

*******************************************************************************/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
var axios_1 = __importDefault(require("axios"));
/**
 * @ignore
 */
// tslint:disable-next-line:no-var-requires
var version = require("../../../package.json").version;
function Request() {
    return axios_1.default.create({
        headers: {
            "X-Client-Name": "boa-sdk-ts",
            "X-Client-Version": version,
        },
    });
}
exports.Request = Request;
//# sourceMappingURL=Request.js.map